<template>
  <div class="home-index">
    <Purchase v-if="role == 'purchase'"></Purchase>
    <SearchHome v-if="role == 'supplier'"></SearchHome>
  </div>
</template>

<script>
import Purchase from "@/views/purchase/Purchase.vue";
import SearchHome from "@/views/search-home/SearchHome.vue";
export default {
  name: "HomeIndex",
  components: {
    Purchase,
    SearchHome,
  },
  data() {
    return {
      role: "", // supplier=供应商,purchase=采购方
    };
  },
  mounted() {
    this.role = localStorage.getItem("role");
  },
};
</script>
